import React from 'react';

const Burger: React.FC = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23 20" fill="none" {...props}>
    <rect width="22.154" height="2.769" x="0.231" y="8.692" fill="currentColor" rx="1.385"></rect>
    <rect width="22.154" height="2.769" x="0.231" y="0.385" fill="currentColor" rx="1.385"></rect>
    <rect width="22.154" height="2.769" x="0.231" y="17" fill="currentColor" rx="1.385"></rect>
  </svg>
);

export default Burger;
